import { render } from "./Base.vue?vue&type=template&id=5bdfdff0&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5bdfdff0"

export default script